import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

export class LegalBusinessNameField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "Best Business",
      propertyName: "legalBusinessName",
      uiFieldType: "Input",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const businessType = this._model.companyInformation.businessType.value;

    // base case - not applicable without a businessType
    if (!businessType) {
      return false;
    }

    if (
      registeredCountry === "United States" &&
      businessType !== "Sole Proprietorship"
    ) {
      return true;
    } else if (
      (registeredCountry === "Australia" ||
        registeredCountry === "New Zealand") &&
      businessType !== "Sole Trader"
    ) {
      return true;
    } else if (
      registeredCountry === "United Kingdom" &&
      businessType !== "Sole Trader"
    ) {
      return true;
    } else if (
      registeredCountry === "Canada" &&
      businessType !== "Sole Proprietorship"
    ) {
      return true;
    }
    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  get pickList(): null {
    return null;
  }
}
